<div class="db-move-to-10web__purpose-buttons" *ngIf="desktopScore < 90">
  <a class="db-button db-button_yellow" (click)="migrate.emit()"><span class="db-copy-my-website" [innerHTML]="'text_copy.optimize' | dbText"></span></a>
  <div class="db-move-to-10web__button-info">
    <span [innerHTML]="'text_done.automatically' | dbText"></span>
  </div>
</div>

<div  *ngIf="desktopScore >= 90">
  <div class="db-move-to-10web__automated-hosting">
    <div class="db-move-to-10web__title">Your Automated Hosting is 1 Click Away</div>
    <div class="db-move-to-10web__sub-title">Move your website to 10Web for free with 1 click automated migration and automatically <br/>get a super optimized copy of your website hosted at 10Web.</div>
    <div class="db-move-to-10web__automated-hosting-image"><img src="assets/images/migration/migrate_website.png" alt=""/></div>
  </div>
</div>

<div *ngIf="desktopScore < 90">
  <div class="db-move-to-10web__title">Why You Need a 90+ PageSpeed Score</div>
  <div class="db-why-need-block-wrap">
    <div class="db-why-need-block" *ngFor="let point of whyNeedPoints">
      <div class="db-why-need-block-header">
        <span class="db-line"></span>
        <span class="db-header-text" [innerHTML]="point.title"></span>
      </div>
      <div class="db-why-need-desc" [innerHTML]="point.desc"></div>
    </div>
  </div>
</div>

<div class="db-move-to-10web__purpose-buttons">
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore >= 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.my.website' | dbText"></span></a>
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore < 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.optimize' | dbText"></span></a>
  <div class="db-move-to-10web__button-info" *ngIf="desktopScore < 90">
    <span [innerHTML]="'text_done.automatically' | dbText"></span>
  </div>
</div>

<div class="db-move-website-section">
  <div class="db-move-to-10web__title">Why You Should Move Your Website to 10Web</div>
  <div class="db-move-to-10web__move-website">
    <div class="db-move-website-content">
      <div>
        <div class="db-move-website-title-sm">90+ PageSpeed Score</div>
        <div class="db-move-website-desc">
          Getting guaranteed 90+ PageSpeed score <br/> for any website hosted at 10Web with a fully <br/> automated speed optimization solution
        </div>
      </div>
      <div class="db-move-website-content-image">
        <img src="assets/images/migration/90+score.png" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="db-move-to-10web__card-grid">
  <div class="db-move-to-10web__card" *ngFor="let point of pointsCreatedWebsite">
    <div class="db-move-to-10web__card-body">
      <img [src]="point.img" class="db-move-to-10web__card-title">
      <div class="db-move-to-10web__card-title" [innerHTML]="point.title"></div>
      <div class="db-move-to-10web__card-desc" [innerHTML]="point.desc"></div>
    </div>
  </div>
</div>

<div class="db-move-to-10web__purpose-buttons">
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore >= 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.my.website' | dbText"></span></a>
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore < 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.optimize' | dbText"></span></a>
  <div class="db-move-to-10web__button-info" *ngIf="desktopScore < 90">
    <span [innerHTML]="'text_done.automatically' | dbText"></span>
  </div>
</div>

<div class="db-move-to-10web__one-click-section" *ngIf="desktopScore >= 90">

  <div class="db-background-square-2">
    <div class="db-move-to-10web__one-click-section-content" >
    <div class="db-copy-website-content-desc">
      <b> Ready To Migrate to 10Web? </b>
      <p>
        We do all the hard work for you and ensure the highest quality, so you won’t have <br class="db-hide-mobile"/>to waste time on the hassles of hosting and optimization. We fully ensure that <br class="db-hide-mobile"/>your migration will be carried out with no loss of data, time and resources.
      </p>
      <div class="db-copy-website-button-wrap">
        <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore >= 90"><span>copy my website</span></a>
      </div>
    </div>
  </div>
  </div>
</div>

<div *ngIf="desktopScore < 90">
  <h1 class="db-move-to-10web__title">How We Achieved a 90+ PageSpeed Score</h1>
  <div class="db-move-to-10web__checklist" >
    <div class="db-move-to-10web__checklist-item" *ngFor="let checklistItem of checklistItems; let i = index">
      <div class="db-move-to-10web__checklist-left">
        <span class="db-move-to-10web__checklist-item-title">{{checklistItem.text}}
          <span class="db-score-tooltip-icon" dbInfoTooltipHover
                [dbInfoTooltipHoverPosition]="checklistItem.tooltip.length < 50 ? 'bottom-left' : (i%2 === 0  ? 'bottom-left' : 'bottom-right')"
                [dbInfoTooltipHoverBody]="checklistItem.tooltip">
              <i class='db-icon db-icon-info-lined'></i>
          </span>
        </span>
      </div>
      <div class="db-move-to-10web__checklist-right"><i class="db-icon db-icon-checkbox-round"></i></div>
    </div>
  </div>
  <div class="db-move-to-10web__purpose-buttons">
    <a class="db-button db-button_yellow" (click)="migrate.emit()"><span class="db-copy-my-website" [innerHTML]="'text_copy.optimize' | dbText"></span></a>
    <div class="db-move-to-10web__button-info">
      <span [innerHTML]="'text_done.automatically' | dbText"></span>
    </div>
  </div>
</div>


<div class="db-move-to-10web__purpose-buttons">
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore >= 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.my.website' | dbText"></span></a>
  <a class="db-button db-button_yellow" (click)="migrate.emit()" *ngIf="desktopScore < 90"><span class="db-copy-my-website" [innerHTML]="'text_copy.optimize' | dbText"></span></a>
  <div class="db-move-to-10web__button-info" *ngIf="desktopScore < 90">
    <span [innerHTML]="'text_done.automatically' | dbText"></span>
  </div>
</div>

